import { gqlClient } from '@/api/graphql-client';
import { estimateMutationScopeId } from '@/api/mutations/estimates/hydrateEstimateCaches';
import estimateKeys from '@/api/queries/estimates/keyFactory';
import { graphql } from '@/gql';
import { useMutationState, useQuery } from '@tanstack/react-query';

const GetEstimatePreviewQuery = graphql(`
  query GetEstimatePreview($estimateId: ID!) {
    estimate(id: $estimateId) {
      id
      preview {
        template
        context
      }
    }
  }
`);

const useGetEstimatePreview = (estimateId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!estimateId,
    queryKey: estimateKeys.estimatePreview(estimateId),
    queryFn: () =>
      gqlClient.request(GetEstimatePreviewQuery, {
        estimateId: estimateId!,
      }),
    meta: { errorMessage: 'Failed to load estimate preview' },
  });

  const scopeId = estimateId ? estimateMutationScopeId(estimateId) : null;
  const pendingForThisEstimate = useMutationState({
    filters: {
      status: 'pending',
      predicate: (m) => scopeId != null && m.options.scope?.id === scopeId,
    },
  });
  const isOutOfSync = pendingForThisEstimate.length > 0;

  return { preview: data?.estimate?.preview, isOutOfSync, ...rest };
};

export default useGetEstimatePreview;
